export default "__VITE_ASSET__DQiEVcai__"